import { render } from "./NoData.vue?vue&type=template&id=7f82c62d&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=7f82c62d&scoped=true&lang=css"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f82c62d"]])

export default __exports__